import moment, {duration} from 'moment';
import {curry} from 'ramda';
export {default as isTimeDST} from './isTimeDST';
export {default as stdTimezoneOffset} from './stdTimezoneOffset';

function _formatHour(date) {
  let hours = date.getHours(),
    minutes = date.getMinutes();
  const ampm = hours >= 12 ? 'pm' : 'am';

  hours = hours % 12;
  hours = hours ? hours : 12;
  minutes = minutes < 10 ? '0' + minutes : minutes;
  const strTime = hours + ':' + minutes + ' ' + ampm;
  return strTime;
}

export function dateTimeConverter(dateTime) {
  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  const now = new Date();
  const nowDate = now.getDate();
  const nowMonth = months[now.getMonth()];
  const nowYear = now.getFullYear();
  const fullDate = new Date(dateTime);
  const year = fullDate.getFullYear();
  const month = months[fullDate.getMonth()];
  const date = fullDate.getDate();
  const time = _formatHour(fullDate);
  let timeStr = '';

  if (nowDate === date && nowMonth === month && nowYear === year) {
    timeStr = 'today at ' + time;
  } else if (nowDate - 1 === date && nowMonth === month && nowYear === year) {
    timeStr = 'yesterday at ' + time;
  } else {
    timeStr = month + ' ' + date + ', ' + year + ' at ' + time;
  }

  // TODO: need timezone to calculate actual time with offset
  return timeStr;

}

export const displayDateTime = (date) => moment(date).format('MMM Do YYYY, h:mm a');

export const displayDateAndTime = (dateTime) => moment(dateTime).format('l     h:mm:ssa');

export const displayDate = (date) => moment(date).format('M.D.YY');

export const formatMDYY = (date) => moment(date).format('M/D/YY');

// Sep 22, 2017 12:04 PM
export const displayDT = (dateTime) => new moment(dateTime).format('lll');

export const convertTime = (seconds) => {
  const time = duration(seconds, 'seconds');
  // Hours, minutes and seconds
  const hrs = Math.floor(seconds / 3600); // Must calculate directly to avoid day/week/month, etc...
  const mins = time.minutes();
  const secs = time.seconds();

  // Output like "1:01" or "4:03:59" or "123:03:59"
  let ret = '';

  if (hrs > 0) {
    ret += `${hrs}:${mins < 10 ? '0' : ''}`;
  }

  ret += `${mins}:${secs < 10 ? '0' : ''}`;
  ret += `${secs}`;

  return ret;
};

const getUrlDateOrFalse = (url) => {
  const sub = url && url.substring(0, 12);
  return sub && sub.match(/\/\d{4}(\/\d{2}){2}\//i) ? sub : false;
};

export const getUrlDate = curry((view, url) =>
  getUrlDateOrFalse(url) || moment(
    view.model.get('publishedDateTime') || view.model.get('savedDateTime') || undefined
  ).format('[/]YYYY[/]MM[/]DD[/]')
);

export const stripUrlDate = (url) => getUrlDateOrFalse(url) || url;
